const baseUrl: { [key: string]: string } = {
  development: 'http://localhost:3000',
  staging: 'https://precision-fluid-power-staging.herokuapp.com',
  production: 'https://precision-fluid-power-backend.herokuapp.com',
}

let currentEnv = baseUrl[process.env.REACT_APP_ENVIRONMENT || 'development']

export default currentEnv
